import en from './en';
import he from './he';

export default {
  he,
  en,
};